// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3zCVF","imageUploader":"EGiftCard_imageUploader__1iij-"};